import { connect } from 'react-redux'
import DedNumber from './dedNumber'

import { callDashboard } from './resources/utilities'

const mapDispatchToProps = (dispatch) => {
  return {
    callDashboard: (Content) => {
      dispatch(callDashboard(Content))
    },
  }
}

export default connect(null, mapDispatchToProps)(DedNumber)
